// extracted by mini-css-extract-plugin
export default {"DomainField":"_DomainField--wa6UX","SubDomain":"_SubDomain--pZaes","EditButton":"_EditButton--CWESh","Label":"_Label--K0j31"};